



















import { Component, Mixins } from 'vue-property-decorator'
import VhFixMixin from '@/plugins/mixins-vh-fix'
import { Company } from '@/api/model/company'
import { ReferralType, WidgetFlowType } from '@/api/types'
import { Question } from '@/views/Form/Conversation.vue'
import Conversation from '@/views/Form/Conversation.vue'
import axios from 'axios'

const basePath = process.env.VUE_APP_KEYVUE_BACKEND_BASEPATH || ''
const baseUrl = process.env.VUE_APP_KEYVUE_BACKEND_BASEURL

@Component({
    components: {
        Conversation,
    },
})
export default class AgentCosts extends Mixins(VhFixMixin) {
    company: Company = null
    companyLoading: boolean = true
    companyError: boolean = false
    submitted: boolean = null
    submittedAppraisal: boolean = null

    async mounted() {
        await this.loadCompany()
    }

    async loadCompany(): Promise<void> {
        this.companyLoading = true

        try {
            const response = await axios.get(`${baseUrl}${basePath}/companies/` + this.$route.query.company)
            this.company = Company.fromData(response.data)
            if ('companyName' in this.$route.query && this.$route.query.companyName.length) {
                this.company.branding.displayName = this.$route.query.companyName as string
            }
            this.$root.$currentCompany = this.company
        } catch (err) {
            this.companyError = true
        } finally {
            this.companyLoading = false
        }
    }

    get isFormEnabled(): boolean {
        if (!this.company || !this.company.activatedWidgetFlowTypes.includes(WidgetFlowType.AGENT)) {
            return false
        }

        return true
    }

    get questions(): Question[] {
        let questions: Question[] = [
            {
                question: `Hi, je wilt weten wat een makelaar kost? Graag geef ik jou inzicht in deze vraag. Mijn naam is Emma van ${this.company.branding.displayName}. En wat is jouw voornaam?`,
                model: 'firstname',
                inputAttrs: {
                    name: 'Voornaam',
                },
            },
            {
                question: `Oké ${this.answers.firstname}, om een antwoord te kunnen geven, wil ik je graag eerst een paar korte vragen stellen.`,
            },
            {
                question: `Als eerste, wil je weten wat een aankoopmakelaar kost, een verkoopmakelaar of wil je weten de kosten van beide zijn?`,
                model: 'type',
                choices: {
                    purchase: 'Aankoopmakelaar',
                    sale: 'Verkoopmakelaar',
                    both: 'Beide',
                },
            },
            {
                question: `Duidelijk, ${this.answers.firstname}, je bent dus geïnteresseerd in een ${this.formatType(this.answers.type)}. Daar kan ik je zeker mee helpen!`,
            },
        ]

        if (this.answers.type === 'purchase') {
            questions = [].concat(questions, [
                {
                    question: `Een aankoopmakelaar kan veel voor je betekenen als je op zoek bent naar een woning. Want je wil natuurlijk wel jouw ideale woning vinden en kopen voor de beste prijs en voorwaarden.`,
                },
                {
                    question: `Wat is jouw achternaam?`,
                    model: 'lastname',
                    inputAttrs: {
                        name: 'Achternaam',
                    },
                },
            ])
        } else {
            questions = [].concat(questions, [
                {
                    question: `Het is handig om te weten om welke woning het gaat die jij eventueel zou willen verkopen. Wat is de postcode van deze woning?`,
                    model: 'zipcode',
                    inputAttrs: {
                        name: 'Postcode',
                        rules: 'required|zipcode',
                    },
                },
                {
                    question: `En wat is het huisnummer en eventuele toevoeging van deze woning?`,
                    model: 'streetnumber',
                    inputAttrs: {
                        name: 'Huisnummer',
                    },
                },
                {
                    question: `We zijn er bijna, ${this.answers.firstname}. Ik heb vrijwel alles compleet om jou inzicht te kunnen geven. Wat is jouw achternaam?`,
                    model: 'lastname',
                    inputAttrs: {
                        name: 'Achternaam',
                    },
                },
            ])
        }

        questions = [].concat(questions, [
            {
                question: `En wat is jouw e-mail adres?`,
                model: 'email',
                inputAttrs: {
                    name: 'E-mailadres',
                    rules: 'required|email',
                },
            },
            {
                question: `Tot slot, ${this.answers.firstname}, wat is jouw (mobiele) telefoonnummer?`,
                model: 'phonenumber',
                inputAttrs: {
                    name: 'Telefoonnummer',
                },
            },
            {
                question: `We hebben alles om jou de informatie te sturen. Alleen hebben wij nog conform de AVG jouw toestemming nodig om je gegevens op te mogen slaan conform de privacy voorwaarden van ${this.company.branding.displayName}. We gebruiken de gegevens alleen om te voldoen aan jouw verzoek en de opvolging daarvan.`,
                model: 'avg',
                choices: {
                    true: 'Ik ga akkoord',
                    false: 'Ik ga niet akkoord',
                },
                onValidate: (answer): true|string => {
                    if (answer === 'false') {
                        return 'We hebben jouw toestemming nodig om je de informatie te sturen.'
                    }

                    return true
                },
                afterLeave: async (): Promise<void>  => {
                    await this.submit()
                },
            },
        ])

        if (this.submitted === true) {
            questions = [].concat(questions, [
                {
                    question: `Bedankt ${this.answers.firstname}, ik heb mijn collega geïnformeerd dat jij graag inzicht krijgt in de kosten van een ${this.formatType(this.answers.type)}. Deze zal jou spoedig contacten om er voor te zorgen dat jij de juiste informatie ontvangt.`,
                },
            ], this.appraisalQuestions)
        } else if (this.submitted === false) {
            questions = [].concat(questions, [
                {
                    question: `Sorry, er is iets misgegaan. Probeer het later opnieuw.`,
                },
            ])
        }

        return questions
    }

    get appraisalQuestions(): Question[] {
        let questions = []

        if (this.answers.type === 'purchase') {
            questions = [].concat(questions, [
                {
                    question: 'Moet je jouw eigen woning nog verkopen en zou je het leuk vinden om direct een waardebepaling van jouw woning te ontvangen? Je ontvangt deze binnen enkele seconden per e-mail',
                    model: 'appraisal',
                    choices: {
                        true: 'Ja',
                        false: 'Nee',
                    },
                },
            ])

            if (this.answers.appraisal === 'true') {
                questions = [].concat(questions, [
                    {
                        question: `Wat is de postcode van deze woning?`,
                        model: 'zipcode',
                        inputAttrs: {
                            name: 'Postcode',
                            rules: 'required|zipcode',
                        },
                    },
                    {
                        question: `En wat is het huisnummer en eventuele toevoeging van deze woning?`,
                        model: 'streetnumber',
                        inputAttrs: {
                            name: 'Huisnummer',
                        },
                        afterLeave: async (): Promise<void>  => {
                            if (this.answers.appraisal === 'true') {
                                await this.submitAppraisal()
                            }
                        },
                    },
                ])
            }
        } else {
            questions = [
                {
                    question: 'Zou jij het leuk vinden om direct een waardebepaling van jouw woning te ontvangen? Je ontvangt deze binnen enkele seconden per e-mail',
                    model: 'appraisal',
                    choices: {
                        true: 'Ja',
                        false: 'Nee',
                    },
                    afterLeave: async (): Promise<void>  => {
                        if (this.answers.appraisal === 'true') {
                            await this.submitAppraisal()
                        }
                    },
                },
            ]
        }

        if (this.submittedAppraisal === true) {
            questions = [].concat(questions, [
                {
                    question: `Super, bedankt voor je waardebepaling aanvraag. 👍 Ik heb alle gegevens ontvangen en zal de waardebepaling spoedig opstellen en e-mailen. ✉ Nog een hele fijne dag vandaag ${this.answers.firstname}! 👋`,
                },
            ])
        } else if (this.submittedAppraisal === false) {
            questions = [].concat(questions, [
                {
                    question: `Sorry, er is iets misgegaan. Probeer het later opnieuw.`,
                },
            ])
        } else {
            questions = [].concat(questions, [
                {
                    question: `Oké 😊. Nog een hele fijne dag vandaag ${this.answers.firstname}! 👋`,
                },
            ])
        }

        return questions
    }

    answers = {
        type: null,
        firstname: null,
        lastname: null,
        zipcode: null,
        streetnumber: null,
        phonenumber: null,
        email: null,
        avg: null,
        appraisal: null,
    }

    formatType(type: string): string {
        switch (type) {
            case 'purchase':
                return 'aankoopmakelaar'

            case 'sale':
                return 'verkoopmakelaar'
        }

        return 'aan- en verkoopmakelaar'
    }

    async submit(): Promise<void> {
        this.submitted = null

        try {
            await axios.post(`${baseUrl}${basePath}/referrals/create`, {
                company: this.company.resourceIdentifier,
                source: 'emma',
                newSource: this.company.emmaSource?.resourceIdentifier,
                firstname: this.answers.firstname,
                lastname: this.answers.lastname,
                streetnumber: this.answers.streetnumber,
                zipcode: this.answers.zipcode,
                email: this.answers.email,
                phonenumber: this.answers.phonenumber,
                type: this.answers.type === 'purchase' ? ReferralType.PURCHASE : ReferralType.SALE,
                data: {
                    streetnumber: this.answers.streetnumber,
                    zipcode: this.answers.zipcode,
                    tag: this.$route.query.tag || null,
                    utm_source: this.$route.query.utm_source || null,
                    utm_medium: this.$route.query.utm_medium || null,
                    utm_campaign: this.$route.query.utm_campaign || null,
                    utm_term: this.$route.query.utm_term || null,
                    utm_content: this.$route.query.utm_content || null,
                    form_identifier: this.answers.type === 'purchase' ? 'agent_costs_purchase' : 'agent_costs_sale',
                },
            })

            this.submitted = true
        } catch (err) {
            this.submitted = false
        }
    }

    async submitAppraisal(): Promise<void> {
        this.submittedAppraisal = null

        try {
            await axios.post(`${baseUrl}${basePath}/referrals/create`, {
                company: this.company.resourceIdentifier,
                source: 'emma',
                newSource: this.company.emmaSource?.resourceIdentifier,
                firstname: this.answers.firstname,
                lastname: this.answers.lastname,
                streetnumber: this.answers.streetnumber,
                zipcode: this.answers.zipcode,
                email: this.answers.email,
                phonenumber: this.answers.phonenumber,
                type: ReferralType.APPRAISAL,
                data: {
                    streetnumber: this.answers.streetnumber,
                    zipcode: this.answers.zipcode,
                    tag: this.$route.query.tag || null,
                    utm_source: this.$route.query.utm_source || null,
                    utm_medium: this.$route.query.utm_medium || null,
                    utm_campaign: this.$route.query.utm_campaign || null,
                    utm_term: this.$route.query.utm_term || null,
                    utm_content: this.$route.query.utm_content || null,
                    form_identifier: 'agent_costs_appraisal',
                },
            })

            this.submittedAppraisal = true
        } catch (err) {
            this.submittedAppraisal = false
        }
    }
}
